"use client";

import React from "react";
import Map, { Marker } from "react-map-gl/maplibre";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/sharp-solid-svg-icons";
export const mapToken =
  "eyJkcGZ4IjogImNfb2dfYl9zeXN0ZW1lcl93b3JsZCIsICJyZWYiOiAiR3JlZW5sYW5kIiwgInBhciI6ICJjX29nX2Jfc3lzdGVtZXIiLCAicHJpdnMiOiAicmdkamhmVlk3R3RFQTNCWiJ9.UH1hNUReClx6Vp2jtR5z/UJkegSZHH3FFXd7zr7UIz4dJpvKwfI3g74+HUCa0X5590Pt9EfbDlF0MBfD5M6+Hg";
import "maplibre-gl/dist/maplibre-gl.css";

const MapWrapper: React.FC<{ longitude: number; latitude: number }> = ({
  longitude,
  latitude,
}) => {
  return (
    <Map
      initialViewState={{
        longitude: longitude,
        latitude: latitude,
        zoom: 14,
      }}
      cooperativeGestures={true}
      attributionControl={false}
      mapStyle={`https://c_og_b_systemer_world.tiles.viamap.net/v1/style.json?token=${mapToken}`}
    >
      <Marker longitude={longitude} latitude={latitude} anchor="bottom">
        <FontAwesomeIcon
          className="size-10 text-[#3C3C3B]"
          icon={faLocationDot}
        />
      </Marker>
    </Map>
  );
};

export default MapWrapper;
